import React from "react";
import InputColor from "../../../../views/dashboard/settings/branding/InputColor";

// Shared training/nutrition column for the add/edit phase template forms -
// both tracks render identically (same row shape, same "Add New" button),
// only the data feeding them differs, so that's all callers pass in.
export const PhaseTrackColumn = ({
  title,
  rows,
  placeholderPhaseName,
  addNewLabel,
  onAddPhase,
  onChangePhase,
  onRemovePhase,
}) => (
  <div className="phase-track-section">
    <span className="phase-track-title">{title}</span>
    {rows.map(({ phase, i }) => (
      <div role="wrapper" className="phase" key={`track-phase-${i}`}>
        <input
          type={"text"}
          id={`phaseName${i}`}
          className="phase-name text-input"
          name={"phaseName"}
          placeholder={placeholderPhaseName}
          defaultValue={phase.phaseName}
          onChange={({ target: { value } }) =>
            onChangePhase("phaseName", value, i)
          }
        />
        <InputColor
          onChange={({ target: { value } }) =>
            onChangePhase("phaseColor", value, i)
          }
          value={phase.phaseColor}
          customClassNames={"phase-color"}
        />
        <img
          src="/img/new-icons/red-trash.svg"
          onClick={() => onRemovePhase(i)}
          role="remove"
        />
      </div>
    ))}
    <div className="add-phase-row-wrapper">
      <button type="button" className="btn-add-phase" onClick={onAddPhase}>
        <span>{addNewLabel}</span>
      </button>
    </div>
  </div>
);
